import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import React, { Component } from "react"
import DiscountType from "./DiscountType"
import BlockedCoupon from "./BlockedCoupon"
import MerchantsList from "./MerchantsList";
import BasicCountInfo from "../Dashboard/BasicCountInfo"
import OrderCounterInfo from "../Dashboard/orderCounterInfo"
import Settings from './CommonSettings';
import ClientInfo from './ClientInfo';
import ShopifyPlus from "./shopifyPlus";
import HeadlessStore from "./HeadlessStore";
import StoreBlocked from "./StoreBlocked";
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { formatToShortHand } from "../../helpers/common_helper"
import { Link } from "react-router-dom";
import { withRouter } from "../../components/Common/withRouter";
import {
    Container,
    Row,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Button,
    Spinner,
} from "reactstrap"

// Utilities
import {
    createNotificationHelpers,
    fetchMerchantInfo,
    fetchOrdersCount,
    fetchMerchantsDataFilter,
    fetchCouponCodes,
    fetchBlockedOrders,
    updateCouponCodeStatus,
    updateProductMetafield,
    updateStoreCollectionsMetafield,
    transformCouponsToTableData,
    transformBlockedOrdersToTableData,
    mapRevenueData,
    formatDatePeriod,
    COUPON_CODES_TABLE_COLUMNS,
    BLOCKED_ORDERS_TABLE_COLUMNS,
    MESSAGES,
    extractRecordId
} from "../utils";
import {
    getAppBlockStatus,
    extractLocationData,
    getDomainToFetch,
    createMetafieldHandler,
    getInitialMerchantState,
    TIMELINE_OPTIONS,
    buildInitializationState
} from "../utils/merchantDetailsHelpers";
import {
    REVENUE_CARDS_ROW_1,
    REVENUE_CARDS_ROW_2,
    REVENUE_CARDS_ROW_3,
    ACTIVE_STORE_ACTIONS,
    TABLE_CONFIGS,
    TABLE_PAGINATION_OPTIONS,
    DEFAULT_TABLE_ENTRIES,
    COMMON_STYLES
} from "../utils/merchantDetailsConstants";

class MerchantsDetails extends Component {
    constructor(props) {
        super(props)
        this.state = getInitialMerchantState();

        // Initialize notification helpers
        const { notify_info, notify_error, notify_success } = createNotificationHelpers();
        this.notify_info = notify_info;
        this.notify_error = notify_error;
        this.notify_success = notify_success;
    }

    initializeFromData = (store_details = {}, storeStatus = "active", overrides = {}) => {
        this.setState(buildInitializationState(store_details, storeStatus, overrides));
    }

    /**
     * Fetches merchant info by shop domain
     */
    fetchMerchantInfoByShop = async (shop, storeStatus) => {
        const result = await fetchMerchantInfo(shop, this.notify_error);
        if (result) {
            this.initializeFromData(result, storeStatus);
            return result;
        }
        return null;
    }
    taggle = () => this.setState(prev => ({ dropdownOpen: !prev.dropdownOpen }))

    /**
     * Loads all dependent data for a merchant
     */
    loadMerchantData = async (store_domain, current_period_start) => {
        const updateState = (updates) => this.setState(prev => ({ ...prev, ...updates }));
        const emptyTable = { columns: [], rows: [] };

        // Parallel loading
        const [ordersCount, revenueData, coupons, blockedOrders] = await Promise.all([
            fetchOrdersCount(store_domain, current_period_start, this.notify_error),
            fetchMerchantsDataFilter(store_domain, 'ALL', this.notify_error),
            fetchCouponCodes(store_domain, this.notify_error),
            fetchBlockedOrders(store_domain, this.notify_error)
        ]);

        // Batch state updates
        const stateUpdates = {
            ...(ordersCount !== null && { current_orders: ordersCount }),
            ...(revenueData && mapRevenueData(revenueData)),
            coupon_list: (Array.isArray(coupons))
                ? transformCouponsToTableData(coupons, COUPON_CODES_TABLE_COLUMNS, this.handleClick)
                : emptyTable,
            blocked_orders: (Array.isArray(blockedOrders))
                ? transformBlockedOrdersToTableData(blockedOrders, BLOCKED_ORDERS_TABLE_COLUMNS)
                : emptyTable,
            isCouponLoading: false,
            isBlockedOrderLoading: false,
            isLoading: false
        };

        updateState(stateUpdates);
    }

    /**
     * Handles fetching merchant info and loading dependent data
     */
    handleFetchAndLoad = async (domain, status) => {
        try {
            const fetched = await this.fetchMerchantInfoByShop(domain, status);
            this.loadMerchantData(fetched.store_domain, fetched.current_period_start);
        } catch {
            window.location.href = '/stores';
        }
    };

    componentDidMount() {
        const { location = {} } = this.props;
        const { data, storeStatus } = extractLocationData(location);
        const store_details = data ? { ...data } : null;

        console.log(store_details)
        // If no data or minimal data, fetch from domain
        if (!store_details || Object.keys(store_details).length < 3) {
            const domainToFetch = getDomainToFetch(location, data);
            return domainToFetch
                ? this.handleFetchAndLoad(domainToFetch, storeStatus)
                : (window.location.href = '/stores');
        }

        // Initialize with existing data
        const { app_block, storefront, ...overrides } = data;
        this.initializeFromData(store_details, storeStatus, {
            ...overrides,
            app_block_status: getAppBlockStatus(storefront, app_block)
        });

        // Load dependent data
        const { store_domain, current_period_start } = store_details;
        console.log({ store_domain, current_period_start })
        if (store_domain && current_period_start) {
            this.loadMerchantData(store_domain, current_period_start);
        } else if (store_domain) {
            this.fetchMerchantInfoByShop(store_domain, storeStatus)
                .then(fetched =>
                    this.loadMerchantData(store_domain, fetched.current_period_start)
                );
        }
    }

    /**
     * Creates coupon button element
     */
    createCouponButton = (coupon, fullId, isActive) => (
        <Button
            color={isActive ? "danger" : "success"}
            size='sm'
            onClick={() => this.handleClick(coupon.fullId || fullId, isActive ? 'deactive' : 'active')}
        >
            {isActive ? 'Disable' : 'Enable'}
        </Button>
    );

    /**
     * Updates coupon in list
     */
    updateCouponInList = (coupon, fullId, status) => {
        const price_rule_status = status === 'active' ? 'ACTIVE' : 'EXPIRED';
        const isActive = price_rule_status === 'ACTIVE';

        return {
            ...coupon,
            status: price_rule_status,
            button: this.createCouponButton(coupon, fullId, isActive)
        };
    }

    /**
     * Handles coupon status toggle
     */
    handleClick = async (fullId, status) => {
        const { store_domain, coupon_list } = this.state;
        const success = await updateCouponCodeStatus(store_domain, fullId, status, this.notify_error);
        if (!success) return;

        const extractedId = extractRecordId(fullId);
        this.setState({
            coupon_list: {
                ...coupon_list,
                rows: coupon_list.rows.map(coupon =>
                    (coupon.id === extractedId || coupon.fullId === fullId)
                        ? this.updateCouponInList(coupon, fullId, status)
                        : coupon
                )
            }
        });
    }

    changeValue = async (value) => {
        const { store_domain } = this.state;
        const revenueData = await fetchMerchantsDataFilter(store_domain, value, this.notify_error);
        if (revenueData) this.setState(mapRevenueData(revenueData));
    }

    /**
     * Generic handler for metafield updates
     */
    handleMetafieldUpdate = (updateFn, successMessage) => async (shop, metafield_key, metafield_value) => {
        await createMetafieldHandler(updateFn, successMessage)(
            shop,
            metafield_key,
            metafield_value,
            (loading) => this.setState({ isLoading: loading }),
            this.notify_error,
            this.notify_success
        );
    }

    handleActionProduct = this.handleMetafieldUpdate(
        updateProductMetafield,
        MESSAGES.PRODUCT_METAFIELD_UPDATE_SUCCESS
    );

    handleActionCollections = this.handleMetafieldUpdate(
        updateStoreCollectionsMetafield,
        MESSAGES.COLLECTIONS_METAFIELD_UPDATE_SUCCESS
    );

    /**
     * Formats currency value
     */
    formatCurrency = (val) => `$ ${formatToShortHand(val)}`;

    /**
     * Formats revenue card value based on config
     */
    formatRevenueValue = (value, { isNumber, formatFn, suffix }) => {
        if (suffix) return `${value}${suffix}`;
        if (formatFn) return this.formatCurrency(formatFn(value));
        if (isNumber) return value;
        return this.formatCurrency(value);
    };

    render() {
        const {
            store_details = {},
            storeStatus,
            store_name,
            store_domain,
            isLoading,
            cartLocation,
            publicAccessToken,
            collectionBaseUrl,
            is_shopify_plus,
            is_headless_store,
            is_blocked,
            reason,
            current_orders,
        } = this.state;

        console.log(this.state)
        console.log({ is_blocked, reason });

        const isActive = storeStatus === 'active';

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Merchant Details</title>
                    </Helmet>
                    <ToastContainer />
                    <Container fluid>
                        {/* Render Breadcrumb */}
                        <Breadcrumbs
                            title={("Merchant Details")}
                            breadcrumbItem={`${store_name}`}
                        />
                        <Row style={COMMON_STYLES.rowMargin}>
                            <Col sm="auto" className="d-flex align-items-center gap-2">
                                {isLoading ? <Spinner color="primary" size="sm" /> : null}
                                <Link to={{
                                    pathname: "/stores",
                                }}>
                                    <Button className="btn btn-dark">
                                        <i className="fa fa-arrow-left"></i> Back to Stores
                                    </Button>
                                </Link>
                            </Col>

                            <Col sm="auto" className="d-flex align-items-center">
                                <Link to={{
                                    pathname: "/coupon-scanner",
                                    search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined,
                                    state: { data: { store: store_domain } }
                                }}>
                                    <Button className="btn btn-primary">
                                        <i className="fa fa-eye"></i> Coupon Scanner
                                    </Button>
                                </Link>
                            </Col>
                            {isActive && ACTIVE_STORE_ACTIONS.map(({ label, handlerKey }, idx) => (
                                <Col key={idx} sm="3" style={COMMON_STYLES.flexCenter}>
                                    <div>
                                        <Button
                                            className="btn btn-danger"
                                            onClick={() => this[handlerKey](store_domain, 'veeper_status', 'disabled')}
                                        >
                                            Disable {label}
                                        </Button>
                                        {' '}
                                        <Button
                                            className="btn btn-success"
                                            onClick={() => this[handlerKey](store_domain, 'veeper_status', 'enabled')}
                                        >
                                            Enable {label}
                                        </Button>
                                    </div>
                                </Col>
                            ))}
                            <Col sm={2} style={COMMON_STYLES.flexCenter}>
                                <Dropdown
                                    isOpen={this.state.singlebtn1}
                                    toggle={() => this.setState(prev => ({ singlebtn1: !prev.singlebtn1 }))}
                                >
                                    <DropdownToggle className="btn btn-secondary" caret>
                                        Timeline <i className="mdi mdi-chevron-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {TIMELINE_OPTIONS.map(({ value, label }) => (
                                            <DropdownItem key={value} onClick={() => this.changeValue(value)}>
                                                {label}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </Row>
                        {[REVENUE_CARDS_ROW_1, REVENUE_CARDS_ROW_2, REVENUE_CARDS_ROW_3].map((rowConfig, rowIdx) => (
                            <Row key={rowIdx}>
                                {rowConfig.map((config, idx) => {
                                    const value = this.state[config.key];
                                    return (
                                        <BasicCountInfo
                                            key={idx}
                                            field={config?.field}
                                            store_domain={store_domain}
                                            data={this.formatRevenueValue(value, config)}
                                            store_details={store_details}
                                            store_status={storeStatus}
                                            edit={config.edit}
                                            colSize="3"
                                            linkUrl={config.linkUrl}
                                            title={config.title}
                                        />
                                    );
                                })}
                            </Row>
                        ))}

                        {isActive &&
                            <Row>
                                <BasicCountInfo field="public_access_token" store_domain={store_domain} data={publicAccessToken} store_details={store_details} store_status={storeStatus} edit={true} colSize="3" linkUrl="placement-edit" title="Storefront Token [Headless]" />
                                <BasicCountInfo field="collection_base_url" store_domain={store_domain} data={collectionBaseUrl} store_details={store_details} store_status={storeStatus} edit={true} colSize="3" linkUrl="placement-edit" title="Collections Base URL [Headless]" />
                                <BasicCountInfo field="cart_location" store_domain={store_domain} data={cartLocation} store_details={store_details} store_status={storeStatus} edit={true} colSize="3" linkUrl="placement-edit" title="CartId Location [Headless]" />
                                <DiscountType store_domain={store_domain} store_details={store_details} store_status={storeStatus} is_campaign={true} colSize="3" title="Campaign Metafields" />
                            </Row>
                        }
                        {store_domain ? (
                            <React.Fragment>
                                <Row>
                                    <Settings store_domain={store_domain} store_details={store_details} store_status={storeStatus} title="Settings" colSize="3" />
                                    <BlockedCoupon store_domain={store_domain} store_details={store_details} store_status={storeStatus} title="Subscription Plan" colSize="3" is_plan={true} />
                                    <OrderCounterInfo title={`Orders [ ${formatDatePeriod(store_details?.current_period_start)} - ${formatDatePeriod(store_details?.current_period_end)} ]`} package_orders={store_details.plan_info?.orders || 0} current_orders={current_orders} colSize="3" />
                                    <DiscountType store_domain={store_domain} store_details={store_details} store_status={storeStatus} is_campaign={false} is_selector={true} colSize="3" title="Upgrade Created At" />
                                    <ShopifyPlus store_domain={store_domain} is_shopify_plus={is_shopify_plus} title="Shopify Plus" colSize="3" />
                                    <HeadlessStore store_domain={store_domain} is_headless_store={is_headless_store} title="Headless Store" colSize="3" />
                                    <BlockedCoupon store_domain={store_domain} store_details={store_details} store_status={storeStatus} is_campaign={false} is_selector={true} colSize="3" title="Blocked Coupon List" />
                                </Row>
                                <Row>
                                    <StoreBlocked store_domain={store_domain} is_blocked={is_blocked} reason={reason} title="Blocked Store" colSize="3" />
                                    <ClientInfo store_details={store_details} title="Client Info" colSize="3" />
                                </Row>

                            </React.Fragment>

                        ) : (
                            <Row>
                                <Col sm="12" style={COMMON_STYLES.spinnerCenter}>
                                    <Spinner color="primary" />
                                </Col>
                            </Row>
                        )}
                        {isActive && (
                            <Row>
                                {TABLE_CONFIGS.map(({ size, loadingKey, dataKey, title, subtitle }) => (
                                    <Col key={title} xl={size}>
                                        <h4 className="header-title mt-4">{title}</h4>
                                        <MerchantsList
                                            loading={this.state[loadingKey]}
                                            data={this.state[dataKey]}
                                            option={TABLE_PAGINATION_OPTIONS}
                                            default_entries={DEFAULT_TABLE_ENTRIES}
                                            title={subtitle}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

MerchantsDetails.propTypes = {
    t: PropTypes.any,
    location: PropTypes.object
}
export default withRouter(MerchantsDetails)
